import card_1 from '../../assets/images/solutions/solutions-card-1.webp';
import card_2 from '../../assets/images/solutions/solutions-card-2.webp';
import card_3 from '../../assets/images/solutions/solutions-card-3.webp';
import card_4 from '../../assets/images/solutions/solutions-card-4.webp';

import dfm1 from '@/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser1.webp';
import dfm2 from '@/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser2.webp';
import dfm3 from '@/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser3.webp';
import dfm4 from '@/app/[locale]/common/assets/images/solutions/fuel-consumption-monitoring/dfm-senser4.webp';

import predictive_maintrance_card1 from '../../assets/images/products/products-card-1.webp';
import predictive_maintrance_card2 from '../../assets/images/products/products-card-2.webp';
import predictive_maintrance_card3 from '../../assets/images/products/products-card-4.webp';

import {APP_ROUTES} from "../app";

export const SOLUTIONS_PAGE_LABELS = {
    SOLUTIONS: 'Solutions',
    FUEL_CONSUMPTION_MONITORING: 'Fuel Consumption Monitoring',
    MONITORING_WAYS: 'Ways Of Monitoring',
    AXLE_LOAD_MONITORING: 'Axle Load Monitoring',
    METHODS_MEASUREMENT: 'Methods Of Measurement',
    ENGINE_PERFORMANCE_MONITORING: 'Engine Run Time And Performance Monitoring',
    USED_MONITORING: 'Where Monitoring Is Used',
    BENEFITS: 'Benefits',
    IMPLEMENTATION_MONITORING: 'Implementation Of Monitoring',
    PREDICTIVE_MAINTRANCE: 'Predictive Maintrance',
    APPLICATION_AREAS: 'Application areas',
    IMPLEMENTING: 'Implementing',
    PARAMETER_MONITORING: 'Parameter Monitoring',
    DEVICE_TELEMATICS_EQUIPMENT: 'Device And Telematics Equipment',
    SELECT_EQUIPMENT: 'Select Equipment',
} as const;

export const SOLUTIONS_CARDS_CONTENT = [
    {
        title: 'Fuel consumption monitoring',
        image: card_1,
        href: `${APP_ROUTES.SOLUTIONS}/fuel-consumption-monitoring`,
    },
    {
        title: 'Axle load monitoring',
        image: card_2,
        href: `${APP_ROUTES.SOLUTIONS}/axle-load-monitoring`,
    },
    {
        title: 'Predictive Maintrance',
        image: card_3,
        href: `${APP_ROUTES.SOLUTIONS}/predictive-maintrance`,
    },
    {
        title: 'Engine run time and performance monitoring',
        image: card_4,
        href: `${APP_ROUTES.SOLUTIONS}/engine-performance-monitoring`,
    },
];

export const SOLUTIONS_PAGE_BREAKPOINT_FOR_ICON_COLOR = 600;

export const SOLUTIONS_PAGE_BREAD_CRUMB_CONTENT = {
    SOLUTIONS: {title: 'Solutions', href: APP_ROUTES.SOLUTIONS},
    FUEL_CONSUMPTION_MONITORING: {title: 'Fuel Consumption Monitoring', href: `${APP_ROUTES.SOLUTIONS}/fuel-consumption-monitoring`},
    AXLE_LOAD_MONITORING: {title: 'Axle Load Monitoring', href: `${APP_ROUTES.SOLUTIONS}/axle-load-monitoring`},
    ENGINE_PERFORMANCE_MONITORING: {title: 'Engine run time and performance monitoring', href: `${APP_ROUTES.SOLUTIONS}/engine-performance-monitoring`},
    PREDICTIVE_MAINTRANCE: {title: 'Predictive Maintrance', href: `${APP_ROUTES.SOLUTIONS}/predictive-maintrance`},
};

export const FUEL_CONSUMPTION_MONITORING_PAGE_TEXTS = {
    WAYS_TITLE: 'Fuel consumption monitoring by measuring fuel flow rate in engine’s fuel lines',
};

export const FUEL_CONSUMPTION_MONITORING_PAGE_DFM_IMAGES = [
    dfm1, dfm2, dfm3, dfm4
];

export const FUEL_CONSUMPTION_MONITORING_PAGE_CARDS_CONTENT = {
    MEASURING_FUEL_FLOW_RATE: {
        DISADVANTAGES: [
            'Fuel flow sensor installation requires time and sufficient qualification of installation specialist',
            'Installation costs are higher than for other fuel consumption control methods',
        ],
        ADVANTAGES: [
            'High accuracy of fuel rate measurement',
            'Fuel consumption is correctly measured even for short operation periods',
            'Applicable for off-road (also railroad and water) vehicles, rough terrain has no influence on measurement accuracy',
            'Helps to follow fuel system’s and engine’s health, allows implementing predictive technical maintenance',
        ],
    },
    DETECTING_FUEL_LEVEL: {
        DISADVANTAGES: [
            'Relatively low accuracy, especially in flat-shape fuel tanks',
            'Impossibility to measure fuel consumption during short operation periods, when fuel volume is not changing distinctly',
            'Hard to measure slow fuel draining from tank and impossible to detect fuel theft from return fuel line',
            'Not applicable for machinery operated in rough terrain, quarries, mines where fuel in tank fluctuates noticeably',
        ],
        ADVANTAGES: [
            'Relatively low price',
            'No intervention into engine fuel supply system',
            'Fuel tank refilling and fuel draining volumes can be measured',
        ],
    },
    CAN_BUS: {
        DISADVANTAGES: [
            'Low accuracy – indirect fuel control method (uses calculation method)',
            'Data can be “hidden” by engine manufacturer, i.e. inaccessible for reading',
            'Data can be erratic, corrupted or missing – typical for older vehicles',
        ],
        ADVANTAGES: [
            'Low cost of data reading equipment',
            'Ease connection to CANbus and J1708 bus',
        ],
    },
};

export const AXLE_LOAD_MONITORING_PAGE_CARDS_CONTENT = {
    SENSOR_INSTALLATION: {
        DISADVANTAGES: [
            'Requires qualified technician for proper sensor installation;',
            'Calibration of sensor and telematics unit configuration are required.',
        ],
        ADVANTAGES: [
            'Possibility to be installed on vehicle with leaf spring suspension system;',
            'Data accuracy is usually higher comparing to CAN bus data;',
            'Can be used for diagnostics of air suspension system during technical check up;',
            'Allows axle load data monitoring via BLE on smartphone (wireless GNOM sensors).',
        ],
    },
    READING_AXLE_WEIGHT: {
        DISADVANTAGES: [
            'Axle weight data is rarely available in CAN bus;',
            'No data in CAN bus of vehicles with spring suspension;',
            'Not possible to use on old vehicles, which don’t have CAN bus',
            'Accuracy of CAN data is often lower comparing to additional sensors;',
            'No CAN bus data when ignition is off.',
        ],
        ADVANTAGES: [
            'Low cost of solution itself (but the preparation works could be more expensive);',
            'Easy to install contactless CAN bus readers can be used for getting axle weight data;',
            'CAN bus readers are quicker to install then additional axle load sensors.',
        ],
    }
};

export const AXLE_LOAD_MONITORING_PAGE_TEXTS = {
    SENSOR_INSTALLATION_TITLE: 'Axle load sensor installation',
    CAN_BUS_TITLE: 'Reading axle weight from CAN bus',
    GNOM: [
        'Axle load monitoring systems often use additional sensors such as GNOM. These sensors can transmit load data both via wires and over the air (BLE, Bluetooth 4.X).',
        'To achieve high accuracy, the sensor must be calibrated after installation: loads are placed one by one in the vehicle body or trailer, and a correspondence table is created between the axle load and the sensor output signal.',
        'The axle load sensor transmits data to the telematics device and fleet management software. The wireless GNOM sensor with BLE allows the driver to carry out on-board weighing during loading, preventing the axle load limit from being exceeded.',
    ],
    CAN_BUS: [
        'Modern vehicles are usually equipped with a CAN j1939 data bus. The T-CAN may contain axle load information from standard sensors, but the presence of this data requires verification by a specialist who connects to the bus and reads the parameters.',
        'Sometimes axle load measurement may not be possible due to corrupted or encrypted CAN J1939 data.',
    ],
};

export const ENGINE_PERFORMANCE_MONITORING_PAGE_TEXTS = {
    TOP_BLOCK: [
        'Monitoring engine hours and performance is a key task in fleet management, allowing you to analyze vehicle loads, improve their efficiency, and optimize maintenance costs. It also makes reporting on special equipment more transparent.',
        'Telematics and GPS monitoring systems automate the monitoring of operating hours and modes, eliminating inflated engine hours and fuel consumption. The classic method of accounting via an engine hour meter does not provide data on load and idle time.',
    ],
    IMPLEMENTATION: {
        DIRECT_METHOD: {
            TITLE: 'Direct method using fuel rate measurement',
            TOP_TEXT_BLOCK: {
                LIST: [
                    '«Idling»,',
                    '«Optimal», i.e. normal flow range for a given piece of equipment,',
                    '«Overload», i.e. flow over the normal range.',
                ],
                DESCRIPTION: 'DFM fuel flow meters are installed in the fuel line and measure the actual fuel consumption and engine operating time. They monitor the fuel in the supply and return lines, which allows determining the engine load:',
            },
            BOTTOM_TEXT_BLOCK: {
              LIST: [
                  'The data is stored in the device’s memory and transmitted to a telematics unit or GPS tracker, and then sent to a fleet management service.',
                  'DFM flow meters are compatible with other fuel monitoring devices, such as level sensors, and can be used in a single telematics system.',
              ],
              DESCRIPTION: 'The flagship models of DFM flow meters are equipped with a CAN j1939/S6 interface, which collects more than 40 parameters of fuel consumption and engine operating time. ',
            },
        },
        INDIRECT_WAY: {
            TITLE: 'Indirect way using CAN bus data',
            TEXT_BLOCK: [
                'Total engine run time is determined based on CANbus data using ignition on/off and engine speed information. Formulas or manual data analysis must be used to calculate the load.',
                'For safe connection to CAN bus J1939 or J1708 use contactless readers such as CANCrocodile or 1708Crocodile. Direct connection (twisting or soldering) may cause errors in the ECU operation.',
            ],
        }
    },
};

export const ENGINE_PERFORMANCE_MONITORING_PAGE_CARDS_CONTENT = {
    DIRECT_METHOD: {
        DISADVANTAGES: [
            'Requires time and skill of installer',
        ],
        ADVANTAGES: [
            'Direct fuel measurement principle, uses instant flow rate',
            'Detects different engine load modes',
            'Applicable for equipment with one, two and more engines',
            'DFM flow meters are protected against tampering and interference',
            'Can be integrated to existing telematics system of a fleet',
        ],
    },
    INDIRECT_WAY: {
        DISADVANTAGES: [
            'Data analysis requires many efforts and time, or not possible at all',
            'Some tracking units do not have required input,J1939 data converter is needed',
            'Required CAN bus data is missing or encrypted/hidden by vehicle manufacturer',

        ],
        ADVANTAGES: [
            'Quick installation of Crocodile contactless reader',
            'Allows obtaining additional parameters of engine operation',
        ],
    },
    BENEFITS: [
        {
            title: 'Reduce machinery idling time',
            description: 'Analyzing the causes and duration of equipment downtime helps the fleet manager improve work efficiency, reduce fuel consumption and improve maintenance schedules.',
        },
        {
            title: 'Prevent fuel theft',
            description: 'Real-time monitoring of equipment operation prevents overestimation of fuel consumption and unauthorized draining.',
        },
        {
            title: 'String drivers’ salary to work performed',
            description: 'Accurate recording of engine operating time, taking into account load conditions, makes it possible to calculate the wages of machine operators depending on the actual time worked.',
        },
        {
            title: 'Increase quality of work ',
            description: 'Engine load monitoring prevents idling from being misinterpreted as real work and helps to identify manipulations with the brush of winter equipment or insufficient plow depth on the tractor.',
        },
        {
            title: 'Extend machinery lifetime',
            description: 'Engine load monitoring helps reduce careless operation of equipment, such as high revving with excessive fuel consumption, which reduces engine wear.',
        },
        {
            title: 'Eliminate unnecessary expensive repairs',
            description: 'Recording engine operating time and performance helps plan maintenance based on load, reducing the risk of breakdowns and repair costs.',
        },
    ],
    USED_MONITORING: [
        {
            title: 'Mobile and stationary equipment ',
            description: 'Monitoring engine run time and performance can be used for both mobile and stationary equipment, including on-highway trucks and light commercial vehicles. However, it is most useful for modern fleets.',
        },
        {
            title: 'Advanced machinery ',
            description: 'Modern vehicles have powerful internal combustion engines, sometimes with two or three motors running for a long time. The load on such engines is uneven, as the equipment often switches between idle, optimal and overload modes.',
        },
    ],
};

export const PREDICTIVE_MAINTRANCE_PAGE_TEXTS = {
    TOP_BLOCK: {
        CONTENT: [
            'Proactive maintenance (proactive TO) is a method of maintaining the operability of a vehicle fleet by monitoring parameters and identifying signs of malfunctions.',
            'This approach is an alternative to planned maintenance, which is carried out according to a schedule, ignoring the actual condition of the equipment. Proactive maintenance focuses on the real need for repair, ensuring uninterrupted operation of equipment and reducing costs.',
        ],
        SELECTED_TEXT: 'This allows for repairs and replacement of consumables at the right time.',
    },
    APPLICATION_AREAS: [
        'Preventative maintenance is most effective for modern, complex machines operating in harsh conditions where fuel consumption and wear on the engine or other components are difficult to control.',
        'These machines include mining and quarrying equipment, construction equipment, specialized oil and gas production machines, rail transport, watercraft, and diesel generator sets and power plants.',
    ],
    BENEFITS: {
        TITLE: 'Considering the high costs of complex equipment and maintenance, reaching 50% of fleet expenses, the implementation of 24/7 remote diagnostics and predictive maintenance allows for a significant reduction in costs due to the following advantages:',
        LIST: [
            'Reducing risks of equipment downtime due to unexpected breakdowns',
            'Increasing service life of machinery through careful operation',
            'Optimizing maintenance rapidity – technical team is prepared for work in advance',
            'Improving fuel economy – e.g. fuel consumption does not increase due to wear of fuel filters',
            'Saving on spare parts replacement -part whose resource has not been developed are not serviced',
        ],
    },
    IMPLEMENTING: {
        TEXT: [
            'Predictive maintenance is based on accurate data on the operation of equipment (machines and vehicles). The more parameters are monitored, the more complete the picture of the fleet\'s operation.',
            'Sensors and control units are used to measure parameters. Technoton devices determine more than 10,000 parameters, transmitting data for GPS tracking and analysis.',
        ],
        TITLE: 'Stages of predictive maintenance implementation',
    },
    PARAMETER_MONITORING: {
        ENGINE: {
            TITLE: 'Engine and fuel system',
            TEXT: [
                'Fuel monitoring – instant fuel rate (also called hourly fuel consumption), total fuel used and split by operating modes. Fuel volume in tank and fuel temperature.',
                'Temperature and pressure of engine oil and coolant. Indicates the condition of technical fluids, filters and other consumables',
                'Engine RPM. If RPM alters within the same operation mode, then this may indicate problems with engine or violation of machinery operation rules.',
            ],
        },
        SUSPENSION: {
            TITLE: 'Suspension and braking system',
            TEXT: [
                'Health (wear) of brake pads and other elements of brake system.',
                'Malfunctions of ABS, EPS, ECAS and other electronics assistance systems',
                'Axle load.',
            ],
        },
        ONBOARD: {
            TITLE: 'Onboard electrical equipment',
            TEXT: [
                'On-board network voltage.',
                'Battery voltage, current and temperature.',
            ],
        },
    },
    TELEMATICS_EQUIPMENT: {
        BOLD_TEXT: 'Given the complexity of modern systems with multiple control points',
        TEXT: [
            'Technoton specializes in the development and production of a wide range of sensors, flow meters, readers and CAN i/o modules for monitoring the operating parameters of modern machines.',
            ', Technoton has implemented S6 technology - a wired interface based on CAN J1939/71. This technology allows receiving data from more than 100 on-board devices via a single wired bus connected to one port of the telematics gateway.',
        ],
    },
};

export const PREDICTIVE_MAINTRANCE_PAGE_CARDS_CONTAINER = {
    IMPLEMENTING: [
      {
          title: 'Define operation parameters to be monitored',
          description: 'Compiling a list of important parameters for equipment, the change of which requires maintenance.',
      },
      {
          title: 'Select onboard devices (sensors, readers, gateways)',
          description: 'Types of additional devices, counters, input/output modules and gateways, as well as data available from the main vehicle equipment.',
      },
      {
          title: 'Reduce machinery idling time',
          description: 'A search for patterns – i.e. typical behavior of parameters during normal operation and in a pre-emergency state, identification of a responsible person and a response procedure.',
      },
      {
          title: 'Install the onboard devices, checkout the telematics system',
          description: 'In-field works by telematics system technicians, installation and commissioning, telematics device testing, fleet personnel training for using telematics system.',
      },
      {
          title: 'Reduce machinery idling time',
          description: 'Before predictive maintenance, the telematics system needs to collect data. It is analyzed manually or using machine learning. Specialists service the equipment.',
      },
  ],
    SELECT_EQUIPMENT: [
        {
            label: 'Fuel level sensors',
            href: '/products/fuel-level-sensors',
            image: predictive_maintrance_card1,
        },
        {
            label: 'Fuel flow meters',
            href: '/products/fuel-flow-meters',
            image: predictive_maintrance_card2,
        },
        {
            label: 'Accessories',
            href: '/products/accessories',
            image: predictive_maintrance_card3,
        },
    ],
};